// Generated from ContestParticipantAssign's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestParticipantAssignCollectionFilterGroups
  = | {
    readonly participant: Iri
  }
  | {
    readonly routeAssign: Iri | Iri[]
  }

export const contestParticipantAssignCollectionFilterMapping: FilterDefinitionMapping<ContestParticipantAssignCollectionFilterGroups> = {
  participant: 'participant',
  routeAssign: 'routeAssign',
}

export type ContestParticipantAssignCollectionSort = 'participant.lastName' | 'participant.bibNumber'
